import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { SvgIcon } from '@material-ui/core';

export const PropertyIcon = ({ className, ...props }) => {
  return (
    <SvgIcon className={classnames(className)} {...props} viewBox="0 0 20 20">
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.996 5.00001H10.5707M5.996 7.50001H10.5707M5.996 10H10.5707M5.996 12.5H10.5707M9.73337 17.2917H11.8187M9.73337 17.2917H4.748C4.05875 17.2917 3.5 16.732 3.5 16.0417L3.5 10L3.5 3.95834C3.5 3.26799 4.05875 2.70834 4.748 2.70834H11.8187C12.5079 2.70834 13.0667 3.26799 13.0667 3.95834V8.33334M9.73337 17.2917V15H6.83337V17.2917M11.8187 17.2917C12.5079 17.2917 13.0667 16.732 13.0667 16.0417V13.3333M11.8187 17.2917H15.25C15.9404 17.2917 16.5 16.732 16.5 16.0417V9.58334C16.5 8.89299 15.9404 8.33334 15.25 8.33334H13.0667M13.0667 8.33334V10.8333M15 10.8333H13.0667M13.0667 10.8333V13.3333M15 13.3333H13.0667"
          stroke="#4D5066"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

PropertyIcon.propTypes = {
  className: PropTypes.string,
};
